module.exports = __webpack_public_path__ + "/login_ui/img/vn-bc1915470d9ede629aa801caff01b707.svg";